/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {

  $('#shopify-section-header-elx').addClass('sticky');

  // Sticky header
  $(window).scroll(function () {

    var elx_header = $('#shopify-section-header-elx');
    var elx_header_offset = $('#shopify-section-header-elx').offset().top;

    scroll = $(window).scrollTop();

    if (scroll >= elx_header_offset) {
      elx_header.addClass('sticky');
    }

    if (scroll < 10) {
      elx_header.removeClass('sticky');
    }
  });


  // Gestion du menu desktop : au survol d'un onglet, on affiche son panneau méga-menu
  $('.inline_menu_level1').hover(
    function () {
      $(this).find(".inline_megamenu").stop(true, true).fadeIn(100);
    },
    function () {
      $(this).find(".inline_megamenu").stop(true, true).fadeOut(100);
    }
  )

  // Menu desktop : scroll horizontal au click & drag (en plus de la molette)
  document.querySelectorAll('#header_inline_menu .inline_menu_scroller').forEach(function (scroller) {
    var isDown = false, startX = 0, startScroll = 0, moved = false;

    scroller.addEventListener('mousedown', function (e) {
      isDown = true;
      moved = false;
      startX = e.pageX;
      startScroll = scroller.scrollLeft;
      scroller.style.cursor = 'grabbing';
      e.preventDefault(); // évite la sélection de texte pendant le drag
    });

    window.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      scroller.scrollLeft = startScroll - dx;
    });

    window.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      scroller.style.cursor = 'grab';
    });

    // Si un vrai drag a eu lieu, on annule le clic pour ne pas naviguer involontairement
    scroller.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  });

  // Recherche en haut de page
  $('[data-action="toggle-search"]').click(function (e) {
    e.preventDefault();
    $("#search_top").slideToggle("fast", "swing", function () {
      window.scrollTo(0, 0);
      document.getElementById("search_top_input").focus();
    });
  })

  // Masquer le bouton "more_description" si div trop petit
  if ($('.description div.more_or_less').height() < 70) {
    $('[data-action="more_description"]').hide();
  }

  // Voir plus sur les descriptions produits
  $('[data-action="more_description"]').click(function (e) {
    e.preventDefault();
    more_or_less = $('.description div.more_or_less');
    console.log(more_or_less.outerHeight());
    more_or_less.toggleClass("opened");
    if (more_or_less.hasClass("opened"))
      $(this).html($(this).data("less"));
    else
      $(this).html($(this).data("more"));
  })

  // Les bannières de home page sont cliquables
  $(".elx-banner").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  // Les video de home page sont cliquables
  $(".elx-video-home").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  // Les images centrée de home page sont cliquables
  $(".elx-image-centered").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  // Les deux colonnes text et images sont cliquables
  $(".elx-two-column-img-and-text .image").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  // Certains carrousels sont cliquables, en home notamment
  $(".Slideshow__ImageContainer").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  // Les deux colonnes text et images sont cliquables
  $(".elx-image-text .image").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  // Les deux colonnes text et images sont cliquables
  $(".elx-images-list .image_wrapper").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });

  $(".elx-two-column-images .image1, .elx-two-column-images .image2").click(function () {
    var goto_url = $(this).data('banner_target');
    if (goto_url) {
      window.location.href = goto_url;
    }
  });


  // Sur un bloc de produit, dans les pages dynamique, on affiche une seconde image au rollover
  $(".product_block a").hover(
    function () {
      if ($(this).data("second"))
        $(this).find("img").attr('src', $(this).data("second"));
    },
    function () {
      if ($(this).data("second"))
        $(this).find("img").attr('src', $(this).data("first"));
    }
  )

  // Dans un fiche produit, permet d'afficher le bloc livraison ou le bloc détails
  $(".description_titles span").click(
    function () {
      var $target = $("#" + $(this).data('target'));
      $(".description").not($target.get(0)).removeClass('actif').addClass("hidden");
      $target.addClass("actif").removeClass('hidden');

      $(".description_titles span").not(this).removeClass("actif");
      $(this).addClass("actif");
    }
  )

  // La section "accordéon" qui enrichi certaines pages dynamiques
  $(".accordeon .answer").hide();
  $(".answer").first().slideDown(100, "swing", function () { });
  $(".toggle").first().addClass("opened");

  $(".accordeon .question").click(function () {
    $(".toggle").removeClass("opened");

    if ($(this).next(".answer").css('display') == 'none') {
      $(".answer").slideUp(300, "swing", function () { });
      $(this).next(".answer").slideToggle(300, "swing", function () { });
      $(this).find(".toggle").toggleClass("opened");
    }
    else {
      $(this).next(".answer").slideToggle(300, "swing", function () { });
    }
  });


  // Le menu latéral s'ouvre en fonction de la page dans laquelle on se trouve
  function open_sidemenu(menu_item) {

    // Couleur rouge parce qu'actif
    menu_item.css("color", "#CF162D");

    // Ouvrir une catégorie de niveau 2
    menu_item.css("overflow", "visible");
    menu_item.css("height", "auto");
    menu_item.css("visibility", "visible");
    menu_item.prev('.Collapsible__Button').attr("aria-expanded", "true");

    // Ouvrir une catégorie de niveau 1
    menu_item.parents('.Collapsible__Inner').css("overflow", "visible");
    menu_item.parents('.Collapsible__Inner').css("height", "auto");
    menu_item.parents('.Collapsible__Inner').css("visibility", "visible");
    menu_item.parents('.Collapsible__Inner').prev('.Collapsible__Button').attr("aria-expanded", "true");
  }

  // Trouver dans le menu un lien ou un data-url qui correspond à l'url de la page en cours.
  $current_menu_link = $('.Link[href="' + window.location.pathname + '"]');
  // Trouver dans le fil d'ariane d'une fiche produit l'url en cours
  $product_collection = $('.bread2').attr("href");
  if (typeof $product_collection == 'undefined') {
    $product_collection = $('.bread1').attr("href");
  }
  $current_menu_link_from_product = $('.Link[href="' + $product_collection + '"]');
  open_sidemenu($current_menu_link);
  open_sidemenu($current_menu_link_from_product);


  // Carrousel des cartes sur la fiche de Montre
  $('.carrousel-cartes').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    speed: 400,
    arrow: true,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  // Mise à jour de la date de livraison
  if ($(".estimated_delivery span").length) {
    adjust_delivery_time();
  }

  // Gestion de la réactivation d'email
  $(document).on("submit", "#reactivation-modal form", function (e) {
    e.preventDefault();
    var $that = $(this);
    $that.find(".Alert--error").hide();
    $.ajax({
      url: $(this).data("target"),
      method: "post",
      dataType: 'json',
      data: $(this).serialize() + "&lng=" + $that.data("lng")
    })
      .done(function (data) {
        if (!data.success) {
          $that.find(".Alert--error").html(data.msg).show();
        }
        else {
          if ($that.data("lng") == "fr") {
            $that.prev("h3").html("Merci !");
            $that.replaceWith('<div class="success"><p>Votre compte a bien été identifié, nous venons de vous faire parvenir un email pour le réactiver.</p></div>');
          }
          else {
            $that.prev("h3").html("Thank You!");
            $that.replaceWith('<div class="success"><p>Your account has been identified, we\'ve just sent you an email to reactivate it.</p></div>');
          }
        }
      });
  })

  // Slider sur les carrousels en haut de page Collection.
  $('#more_arrow').on('click', function (e) {
    e.preventDefault();
    var slider = $('.img_cats_wrapper');
    var scrollPos = slider.scrollLeft();
    var item_width = $('.img_cats_wrapper a').width();
    var finalPos = scrollPos + item_width;
    slider.scrollLeft(finalPos);
    manage_arrows(slider, finalPos);
  });

  $('#less_arrow').on('click', function (e) {
    e.preventDefault();
    var slider = $('.img_cats_wrapper');
    var scrollPos = slider.scrollLeft();
    var item_width = $('.img_cats_wrapper a').width();
    var finalPos = scrollPos - item_width;
    slider.scrollLeft(finalPos);
    manage_arrows(slider, finalPos);
  });

  function manage_arrows(slider, finalPos) {

    // Cette condition ne fonctionne pas.
    if (slider[0].scrollWidth < slider.width()) {
      $('#less_arrow').hide();
      $('#more_arrow').hide();
    }
    else {

      if (finalPos <= 0) {
        $('#less_arrow').fadeOut(100);
        $('#more_arrow').show();
      }

      if (finalPos + slider.innerWidth() >= slider[0].scrollWidth) {
        $('#more_arrow').fadeOut(100);
        $('#less_arrow').show();
      }
    }
  }

  // Initialise les flèches du carrousel
  if ($('.img_cats_wrapper').length) {
    manage_arrows($('.img_cats_wrapper'), 0);
  }

  // Gestion de l'affichage des couleurs quand il y en a plus de 25
  if ($('#other_colors').length) {
    var nb_colors = parseInt($('#other_colors').data('nb-colors'));

    if (nb_colors >= 20) {
      // Cacher toutes les couleurs à partir de la 9ème
      $('.colors_wrapper .color_item').each(function(index) {
        if (index >= 12) {
          $(this).addClass('hidden');
        }
      });

      // Calculer le nombre de coloris restants
      var nb_colors_hidden = nb_colors - 12;

      // Récupérer le texte traduit pour "coloris"
      var coloris_text = $('#other_colors').data('coloris-translates');

      // Insérer le bouton "voir plus" après la 12ème pastille
      $('.colors_wrapper .color_item').eq(11).after('<span class="see_more">+ <em>' + nb_colors_hidden + ' ' + coloris_text + '</em></span>');
    }
  }

  // Gestion du clic sur "voir plus" pour afficher toutes les couleurs
  $(document).on('click', '#other_colors .see_more', function() {
    // Afficher toutes les couleurs cachées
    $('.colors_wrapper .color_item.hidden').removeClass('hidden');
    // Supprimer le bouton "voir plus"
    $(this).remove();
  });
});

// Mise à jour de l'id de variante lors d'un changement de selection.
$(document).on('change', 'select[name="upsell_variant_id"]', function () {
  // Récupérer la valeur de l'option sélectionnée
  var selectedVariantId = $(this).val();

  // récupérer le prix de la variante sélectionnée
  var selectedVariantPrice = Number($(this).find('option:selected').data('price')) / 100;

  // Mettre à jour l'attribut data-product_id du bouton dans ce conteneur .upsell_price
  $(this).closest('.upsell_item').find('.upsell_add_to_cart').data('product_id', selectedVariantId);

  // Mettre à jour le prix
  $(this).closest('.upsell_item').find('.upsell_price').html(selectedVariantPrice);
});

// Gestion des clicks sur les boutons Upsell
$(document).on('click', '.upsell_add_to_cart', function (e) {
  e.preventDefault();

  var items = [];

  items.push({ id: String($(this).data('product_id')), quantity: 1 });

  jQuery.post('/cart/add.js', {
    items
  }, function (result) {
    update_header_cart();
  }, 'json');
});



// Mise à jour du nombre d'items dans le panier
function update_header_cart() {
  $.ajax({
    url: '/cart.js',
    dataType: 'json'
  })
    .done(function (data) {
      // Rafraichissement du panier
      /* document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      })); */

      // Ouverture du panier
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { variant: "", quantity: 0 }
      }));

      // Mise à jour du nombre d'items dans le panier (menu)
      if ($(".cart_nb").length) {
        $(".cart_nb").html(data.item_count);
        $(".cart_nb_mobile").html(data.item_count); // en version mobile, la quantité dans le panier est affichée différement
      }
      else {
        $(".cart_nav_item").html($(".cart_nav_item").html() + '&nbsp;(<span class="cart_nb">' + data.item_count + '</span>)');
        $(".cart_nb_mobile").html(data.item_count); // en version mobile, la quantité dans le panier est affichée différement
      }
    });
}

function adjust_delivery_time() {
  var delivery_time = 72; // Nombre moyen d'heures pour être livré
  var now = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/Paris" })).getHours();
  if (now >= 0 && now < 12)
    delivery_time = 48; // Si on passe commande avant midi, on réduit à 48 heures.
  var delivery_date = new Date().addHours(delivery_time); // Jour de livraison supposé, hors jour chômés
  // Si on tombe un samedi ou dimanche, on repousse au lundi suivant
  if (delivery_date.getDay() == 6 || delivery_date.getDay() == 0) {
    var nb_weekend_day = delivery_date.getDay() == 6 ? 2 : 1;
    delivery_date = new Date().addHours(delivery_time + nb_weekend_day * 24);
  }
  // Affichage
  var numero_jour_livraison = delivery_date.getDate();
  var nom_jour_livraison = delivery_date.toLocaleDateString("fr-FR", { weekday: 'long' });
  var nom_mois_livraison = delivery_date.toLocaleDateString("fr-FR", { month: 'long' });
  $(".estimated_delivery span").html(nom_jour_livraison + " " + numero_jour_livraison + " " + nom_mois_livraison);
  $(".estimated_delivery").fadeIn();
}

// Ajoute h Heures à une date existante
Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
};

/* ============================================================================
   UPSELL PDP — produits liés (metafield related_products)

   1. Charge en asynchrone la section "upsell-produit" via la Section Rendering
      API (?section_id=), et l'injecte dans le placeholder .Upsell.
   2. Gère la sélection de variantes (filtrage des options indisponibles) —
      mécanique reprise du projet pdb.
   3. Ajout au panier en Ajax : POST /cart/add.js puis dispatch de l'event
      "product:added" écouté par le drawer Prestige (rerender + ouverture).
   ============================================================================ */
(function () {
  var container = document.querySelector('.Upsell[data-upsell-url]');
  if (!container) return;

  // Produit / variante « source » : la fiche produit sur laquelle l'upsell est affiché.
  // On part de la variante initiale rendue côté serveur, puis on suit la sélection
  // de l'utilisateur via l'event "variant:changed" émis par le thème Prestige.
  var sourceProductId = container.getAttribute('data-source-product-id') || '';
  var sourceVariantId = container.getAttribute('data-source-variant-id') || '';

  document.addEventListener('variant:changed', function (event) {
    if (event.detail && event.detail.variant && event.detail.variant.id) {
      sourceVariantId = String(event.detail.variant.id);
    }
  });

  fetch(container.getAttribute('data-upsell-url'), { credentials: 'same-origin', cache: 'no-store' })
    .then(function (response) {
      return response.ok ? response.text() : Promise.reject(response.status);
    })
    .then(function (html) {
      container.innerHTML = html;
      if (!container.querySelector('.Upsell__Card')) {
        container.remove();
        return;
      }
      container.classList.add('is-loaded');
      initUpsell(container);
    })
    .catch(function () {
      // Échec silencieux : le bloc reste vide, on le retire du flux
      container.remove();
    });

  function initUpsell(root) {
    root.querySelectorAll('.Upsell__Card').forEach(function (card) {
      initVariantSelects(card);
    });

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-upsell-add]');
      if (!button) return;
      event.preventDefault();
      addUpsellToCart(button);
    });
  }

  // ---------- Variantes ----------

  function initVariantSelects(card) {
    var selects = [].slice.call(card.querySelectorAll('.Upsell__CardSelect'));
    if (!selects.length) return;

    var variants = JSON.parse(card.getAttribute('data-variants') || '[]');

    selects.forEach(function (select) { filterUnavailableOptions(select, selects, variants); });

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        selects.forEach(function (other) { filterUnavailableOptions(other, selects, variants); });
        updateVariant(card, selects, variants);
      });
    });

    updateVariant(card, selects, variants);
  }

  function filterUnavailableOptions(targetSelect, allSelects, variants) {
    var optionIndex = parseInt(targetSelect.getAttribute('data-option-index'), 10);

    var selectedOptions = allSelects.map(function (select) {
      return select === targetSelect ? null : select.value;
    });

    [].slice.call(targetSelect.options).forEach(function (option) {
      var testOptions = selectedOptions.slice();
      testOptions[optionIndex] = option.value;

      var hasAvailable = variants.some(function (variant) {
        return variant.available && testOptions.every(function (value, i) {
          return value === null || variant.options[i] === value;
        });
      });

      option.disabled = !hasAvailable;
      option.hidden = !hasAvailable;
    });

    if (targetSelect.selectedOptions[0] && targetSelect.selectedOptions[0].disabled) {
      var firstEnabled = [].slice.call(targetSelect.options).filter(function (o) { return !o.disabled; })[0];
      if (firstEnabled) targetSelect.value = firstEnabled.value;
    }
  }

  function updateVariant(card, selects, variants) {
    var selectedOptions = selects.map(function (select) { return select.value; });

    var matchingVariant = variants.filter(function (variant) {
      return variant.available && variant.options.every(function (option, i) {
        return option === selectedOptions[i];
      });
    })[0];

    var button = card.querySelector('[data-upsell-add]');
    if (!button) return;

    if (matchingVariant) {
      button.setAttribute('data-variant-id', matchingVariant.id);
      if (matchingVariant.priceAmount != null) {
        button.setAttribute('data-variant-price', matchingVariant.priceAmount);
      }
      button.removeAttribute('disabled');
      updatePrice(card, matchingVariant);
    } else {
      button.setAttribute('disabled', 'disabled');
    }
  }

  function updatePrice(card, variant) {
    var priceEl = card.querySelector('.Upsell__CardPrice');
    if (!priceEl || !variant.price) return;

    if (variant.compareAt) {
      priceEl.innerHTML = '<span class="Upsell__CardPrice--sale">' + variant.price + '</span> <s>' + variant.compareAt + '</s>';
    } else {
      priceEl.innerHTML = variant.price;
    }
  }

  // ---------- Ajout au panier ----------

  function addUpsellToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.hasAttribute('disabled')) return;

    // Produit / variante « cible » : le produit upsellé.
    var card = button.closest('.Upsell__Card');
    var targetProductId = card ? card.getAttribute('data-product-id') : '';
    var targetCurrency = card ? card.getAttribute('data-currency') : '';
    // Prix cible envoyé en nombre (arrondi à 2 décimales), pas en chaîne.
    var targetVariantPriceRaw = button.getAttribute('data-variant-price');
    var targetVariantPrice = targetVariantPriceRaw ? Math.round(parseFloat(targetVariantPriceRaw) * 100) / 100 : null;

    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-loading');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      // Propriétés de ligne (préfixe "_" = masquées) : permettent de retrouver
      // le CA upsell via l'Admin API (montant réel, promos déduites).
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          '_upsell_location': 'product_page',
          '_upsell_source_product_variant_id': String(sourceVariantId)
        }
      })
    })
      .then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (response.ok) {
          button.classList.remove('is-loading');
          button.classList.add('is-added');

          // Tracking : on publie l'event APRÈS le succès (et non au clic) pour éviter
          // que des double/triple clics ne faussent les statistiques.
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('upsell_product_added_to_cart', {
              location: 'product_page',
              source_product_id: sourceProductId,
              source_product_variant_id: sourceVariantId,
              target_product_id: targetProductId,
              target_product_variant_id: variantId,
              target_product_variant_price: targetVariantPrice,
              target_product_variant_currency: targetCurrency
            });
          }

          // Le drawer Prestige écoute "product:added" (détail.quantity) : rerender + ouverture
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: { id: parseInt(variantId, 10) }, quantity: 1 }
          }));

          setTimeout(function () {
            button.removeAttribute('disabled');
            button.classList.remove('is-added');
          }, 2000);
        } else {
          button.removeAttribute('disabled');
          button.classList.remove('is-loading');
        }
      })
      .catch(function () {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        button.removeAttribute('disabled');
        button.classList.remove('is-loading');
      });
  }
})();